import React from 'react'
import { Link } from 'react-router-dom'
import { COMPANY_INFO } from '../lib/constants'

export default function Forbidden() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 sm:px-6 py-20">
      <div className="max-w-lg w-full text-center space-y-6">
        <div className="w-16 h-16 rounded-2xl bg-[#18191D] text-rose-500 flex items-center justify-center mx-auto text-2xl shadow-md border border-white/10">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>

        <div className="space-y-2">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#55565C]">
            <span className="w-1.5 h-1.5 rounded-full bg-rose-500" aria-hidden="true" />
            <span>Fejlkode 403</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            Adgang nægtet
          </h1>
          <p className="text-[#55565C] text-sm sm:text-base leading-relaxed">
            Du har ikke tilladelse til at tilgå denne ressource. Hvis du mener, der er tale om en fejl, er du velkommen til at kontakte Jakob.
          </p>
        </div>

        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-[#18191D] hover:bg-[#292A30] text-white font-bold px-6 py-3 transition-colors text-xs uppercase tracking-wider shadow-sm"
          >
            <span>Gå til forsiden</span>
            <span aria-hidden="true">↗</span>
          </Link>

          <a
            href={`tel:${COMPANY_INFO.phoneRaw}`}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3 transition-colors text-xs uppercase tracking-wider shadow-sm whitespace-nowrap"
          >
            <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
            <span>Ring: {COMPANY_INFO.phone}</span>
          </a>
        </div>
      </div>
    </div>
  )
}
